import { selectRootSliceLPR } from '../../Main/selectors';
import { ROOT_SLICE } from './constants';

export const selectThisSlice = state => {
  const slice = selectRootSliceLPR(state);
  if (slice[ROOT_SLICE]) {
    return slice[ROOT_SLICE];
  }

  // else assume state is already LAFDateRange.
  return state;
};

export const selectIsInitialized = state => { 
  const slice = selectThisSlice(state);
  return slice.isInitialized;
}

export const selectSearchText = state => {
  const slice = selectThisSlice(state);
  return slice.searchText;
};

export const selectIsFuzzySearch = state => {
  const slice = selectThisSlice(state);
  return slice.isFuzzySearch;
}
